import { render, staticRenderFns } from "./ProjectsList.vue?vue&type=template&id=eb9e8a8c&scoped=true&"
import script from "./ProjectsList.vue?vue&type=script&lang=js&"
export * from "./ProjectsList.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsList.vue?vue&type=style&index=0&id=eb9e8a8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb9e8a8c",
  null
  
)

export default component.exports